import { ContractRule } from "@/business/shared/commons/validator/validatorsTypes";

export class PasswordRule implements ContractRule {
  esValidationMessage: string;

  constructor(esValidationMessage: string) {
    this.esValidationMessage = esValidationMessage;
  }

  check(value: string, otherValue?: string): boolean {
    const regex = new RegExp(
      /^(?=.*\d)(?=.*[@$!%*#?&.,])[A-Za-z\d@$!%*#?&.,]{8,}$/
    );
    return regex.test(value);
  }
}
